const resetGridbuidlerParams = () => {
    function removeQueryParametersAndUpdateUrl(paramsToRemove) {
        // Get the current URL
        const url = window.location.href;

        // Create a URL object from the current URL
        const urlObj = new URL(url);

        // Create a URLSearchParams object from the search part of the URL
        const searchParams = new URLSearchParams(urlObj.search);

        // Remove the specified parameters
        paramsToRemove.forEach(param => {
            searchParams.delete(param);
        });

        // Set the search part of the URL with the updated searchParams
        urlObj.search = searchParams.toString();

        // Update the URL in the address bar without reloading the page
        window.history.pushState({}, '', urlObj.toString());
    }

    // Example usage
    const paramsToRemove = ['_categories', '_categories_mobile', '_service_types', '_service_types_mobile'];

    removeQueryParametersAndUpdateUrl(paramsToRemove);

}

export { resetGridbuidlerParams }